import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/pricing", label: "Pricing" },
  { to: "/directory", label: "Directory" },
  { to: "/marketplace", label: "Marketplace" },
  { to: "/rr", label: "RR" },
  { to: "/reserve", label: "Reserve" },
  { to: "/certification", label: "Certification" },
  { to: "/news", label: "News" },
  { to: "/events", label: "Education" },
  { to: "/advertising", label: "Advertise" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    setOpen(false);
    navigate("/");
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-black/70 backdrop-blur-2xl border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />

        <div className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors ${
                location.pathname === n.to ? "text-[#D4AF37]" : "text-neutral-300 hover:text-[#D4AF37]"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard">
                <Button variant="ghost" className="text-neutral-200 hover:text-[#D4AF37] hover:bg-white/5">Dashboard</Button>
              </Link>
              <Button onClick={handleLogout} data-testid="nav-logout" variant="outline"
                className="rounded-none border-white/20 text-neutral-200 hover:border-[#D4AF37] hover:text-[#D4AF37] bg-transparent">
                Log out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="text-neutral-200 hover:text-[#D4AF37] hover:bg-white/5">Log in</Button>
              </Link>
              <Link to="/register" data-testid="nav-join">
                <Button className="rounded-none bg-[#D4AF37] text-black hover:bg-[#F0C84B] font-semibold">Join Barbistry</Button>
              </Link>
            </>
          )}
        </div>

        <button className="lg:hidden text-neutral-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-black/95 border-t border-white/10 px-5 py-4 space-y-1">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
              className="block py-2.5 text-neutral-200 hover:text-[#D4AF37]" data-testid={`nav-mobile-${n.label.toLowerCase()}`}>
              {n.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-white/10 flex flex-col gap-2">
            {user ? (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)}><Button className="w-full rounded-none bg-white/5 text-white">Dashboard</Button></Link>
                <Button onClick={handleLogout} className="w-full rounded-none bg-[#D4AF37] text-black">Log out</Button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}><Button variant="outline" className="w-full rounded-none border-white/20 bg-transparent text-white">Log in</Button></Link>
                <Link to="/register" onClick={() => setOpen(false)}><Button className="w-full rounded-none bg-[#D4AF37] text-black">Join Barbistry</Button></Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
